import React from "react";
import { useNavigate } from "react-router-dom";
import "./css/FeaturedCard.css";

export default function FeaturedCard({ item }) {
    const navigate = useNavigate();

    if (!item) return null;

    return (
        <div
            className="featured-card"
            onClick={() => navigate(`/${item.slug}`)}
        >
            <div
                className="featured-bg"
                style={{ backgroundImage: `url(${item.coverImage})` }}
            >
                <div className="featured-gradient" />

                <div className="featured-pill">
                    {item.collection === "guides" ? "Guide" : "Trip"}
                </div>

                <div className="featured-title">
                    {item.title}
                </div>
            </div>
        </div>
    );
}
